import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/routes/no-item-route-styles.scss';
export default function NoItemSelected() {
    return (_jsxs("div", { className: "no-item-route", children: [_jsx("i", { className: "fas fa-fw fa-ballot-check no-item-route__icon" }), _jsx("h2", { className: "no-item-route__title", children: "Select or create an item to begin" })] }));
}
